// extracted by mini-css-extract-plugin
module.exports = {"thirdParty":"ThirdParty_thirdParty__2H5PP","popup":"ThirdParty_popup__37Cln","title":"ThirdParty_title__QWA2y"};